module.exports = __webpack_public_path__ + "static/2-8531ba1ac4f2037106765414db6c0040.jpg";